import { callApi, HTTPMethods } from '@/utils/api';
import KeycloakService from './keycloakService';
import { getApiUrl } from '@/utils/url';
import { UseClientStore } from '@/store/clientStore';

export default {
  async getTeamsRhPortalLink() {
    try {
      await KeycloakService.CallUpdate().then(async () => {
        const config = {
          'Content-Type': 'application/json',
        };

        const clientStore = UseClientStore();

        await callApi({
          path: `${getApiUrl()}/clients/smart-url`,
          method: HTTPMethods.GET,
          body: {},
          options: config,
          errorMessage: '',
          successCallback: (result: any) => {
            if (result?.url_smart) {
              clientStore.setTeamsRHPortalLink(result?.url_smart);
            }
          },
        });
      });
    } catch (err) {
      // we don't want to show notification here as it's not a critical error
      console.log(err);
    }
  },
};
